/**
 * Main scripts file
 * Contains general functionality for the theme
 */

//light/dark theme
document.addEventListener('DOMContentLoaded', () => {
    const themeToggleCheckbox = document.getElementById('theme-toggle-checkbox');
    const root = document.documentElement;
    const logo = document.getElementById('logo');

    // Define logo paths for light and dark themes
    const lightLogo = logo.getAttribute('data-light');
    const darkLogo = logo.getAttribute('data-dark');

    // Function to update theme and logo
    const updateTheme = (theme) => {
        root.classList.remove('theme-light', 'theme-dark');
        root.classList.add(`theme-${theme}`);
        logo.src = theme === 'dark' ? darkLogo : lightLogo;
    };

    // Set initial theme based on stored preference or default to light
    const currentTheme = localStorage.getItem('theme') || 'light';
    updateTheme(currentTheme);
    themeToggleCheckbox.checked = currentTheme === 'dark';

    // Listen for theme changes
    themeToggleCheckbox.addEventListener('change', () => {
        const newTheme = themeToggleCheckbox.checked ? 'dark' : 'light';
        localStorage.setItem('theme', newTheme);
        updateTheme(newTheme);
    });
});


document.addEventListener('DOMContentLoaded', function() {
    // Initialize mobile menu
    const menuToggle = document.querySelector('.menu-toggle');
    const mainNav = document.querySelector('.main-navigation');
    
    if (menuToggle && mainNav) {
        menuToggle.addEventListener('click', function() {
            mainNav.classList.toggle('toggled');
            const expanded = mainNav.classList.contains('toggled');
            menuToggle.setAttribute('aria-expanded', expanded);
        });
    }
    
    // Add basic animations for interactive elements
    const interactiveElements = document.querySelectorAll('a, button, .interactive');
    interactiveElements.forEach(element => {
        element.addEventListener('mouseenter', function() {
            this.style.transition = 'all 0.3s ease';
        });
    });
    
    // Initialize accordions if they exist
    const accordionToggles = document.querySelectorAll('.accordion-toggle');
    accordionToggles.forEach(toggle => {
        toggle.addEventListener('click', function() {
            this.classList.toggle('active');
            const panel = this.nextElementSibling;
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + 'px';
            }
        });
    });
    
    // Add smooth scrolling to anchor links
    document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            e.preventDefault();
            const targetId = this.getAttribute('href');
            const targetElement = document.querySelector(targetId);
            
            if (targetElement) {
                window.scrollTo({
                    top: targetElement.offsetTop - 100,
                    behavior: 'smooth'
                });
            }
        });
    });
});


